"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PAID_SEATS = exports.FreeProductLevels = exports.ProductLevels = exports.SALES_PRODUCT_LEVEL = exports.MARKETING_TRIAL_PRODUCT_LEVEL = exports.MARKETING_PRODUCT_LEVEL = void 0;
var MARKETING_PRODUCT_LEVEL = 'marketingProductLevel';
exports.MARKETING_PRODUCT_LEVEL = MARKETING_PRODUCT_LEVEL;
var MARKETING_TRIAL_PRODUCT_LEVEL = 'marketingTrialProductLevel';
exports.MARKETING_TRIAL_PRODUCT_LEVEL = MARKETING_TRIAL_PRODUCT_LEVEL;
var SALES_PRODUCT_LEVEL = 'salesProductLevel';
exports.SALES_PRODUCT_LEVEL = SALES_PRODUCT_LEVEL;
var ProductLevels = {
  NONE: 'none',
  FREE: 'free',
  STARTER: 'starter',
  BASIC: 'basic',
  PRO: 'pro',
  ENTERPRISE: 'ent'
};
exports.ProductLevels = ProductLevels;
var FreeProductLevels = [ProductLevels.NONE, ProductLevels.FREE];
exports.FreeProductLevels = FreeProductLevels;
var PAID_SEATS = 'paidSeats';
exports.PAID_SEATS = PAID_SEATS;